export default __webpack_public_path__ + "static/media/drawing-man5-focusfill.b2bb6f54.svg";